/**
 *
 * @author Igor Zapororzhets <deadbyelpy@gmail.com>.
 */

'use strict';


/* eslint no-use-before-define: 0*/
/* eslint no-useless-call: 0 */


var app  = require('mag-app'),
    keys = require('stb-keys'),

    Modal = require('mag-component-modal'),
    List  = require('stb-component-list'),
    Scroll    = require('stb-component-scrollbar'),

    nodeMap = require('../node.map.js'),
    listItemRender = require('./list.item'),

    scroll = new Scroll(),
    list = new List({
        size: 5,
        data: [1],
        $node: document.createElement('div'),
        $body: document.createElement('div'),
        scroll: scroll,
        render: function ( $node, data ) {
            console.log('renderCalled');
            if ( !$node.$layout ) {
                $node.innerText = '';

                while ( $node.firstChild ) {
                    $node.removeChild($node.firstChild);
                }

                $node.$layout = $node.appendChild(document.createElement('div'));
                $node.$layout.className = 'mag-component-layout';

                $node.$text = document.createElement('div');

                $node.$layout.appendChild($node.$text);
            }

            $node.$text.innerText = data.name || data.value;
        },
        events: {
            keydown: function ( event ) {
                List.prototype.defaultEvents.keydown.call(this, event);

                console.log(event && event.code);
                console.log('keydown');
                if ( event.code === keys.back ) {
                    event.stop = true;
                    modal.hide();
                }
            },
            'click:item': function ( event ) {
                var self = this;

                console.log('CLICK ITEM!!!!');

                if ( event.$item.data.selected ) {
                    if ( !currentOption.saveImmediate ) {
                        nodeMap.data[currentOption.id].listInstance.$nodeChange(
                            event.$item.value !== nodeMap.data[currentOption.id].initialValue,
                            currentOption,
                            event.$item.data.value
                        );
                        currentOption.emit('select:item', event.$item.data);
                    }

                    setTimeout(function () {
                        modal.hide();
                    }, 0);
                } else {
                    if ( currentOption.saveImmediate ) {
                        if ( typeof currentOption.prepareForSave === 'function' ) {
                            currentOption.prepareForSave.call(currentOption, event.$item.data.value, function ( error, afterSave ) {
                                if ( !error ) {
                                    currentOption.saver.call(currentOption, function ( error, callback ) {
                                        if ( !error ) {
                                            nodeMap.data[currentOption.id].initialValue = event.$item.data.value;

                                            self.data.forEach(function ( item ) {
                                                item.selected = false;
                                            });
                                            event.$item.data.selected = true;
                                            if ( typeof afterSave === 'function' ) {
                                                afterSave.call(currentOption);
                                            }
                                        }

                                        if ( typeof callback === 'function') {
                                            callback.call(currentOption, error);
                                        }
                                    });
                                }
                            });
                        } else {
                            currentOption.saver.call(currentOption, function ( error, callback ) {
                                if ( !error ) {
                                    self.data.forEach(function ( item ) {
                                        item.selected = false;
                                    });
                                    event.$item.data.selected = true;
                                    nodeMap.data[currentOption.id].initialValue = event.$item.data.value;
                                }

                                if ( typeof callback === 'function') {
                                    callback.call(currentOption, error);
                                }
                            });
                        }
                    } else {
                        nodeMap.data[currentOption.id].listInstance.$nodeChange(
                            event.$item.data.value !== nodeMap.data[currentOption.id].initialValue,
                            currentOption,
                            event.$item.data.value
                        );
                        currentOption.emit('select:item', event.$item.data);
                    }

                    setTimeout(function () {
                        modal.hide();
                    }, 0);
                }
            },
            'focus:item': function ( event ) {
                if ( currentOption ) {
                    currentOption.emit('focus:item', event.$curr.data);
                }
            },
            focus: function () {
                console.log('FOCUS ME');
            }
        }
    }),
    modal = new Modal({
        title: 'Choose',
        children: [
            list,
            scroll
        ],
        events: {
            show: function () {
                app.activePanelSet.blur();

                setTimeout(function () {
                    // bug: http://192.168.1.220:3000/issues/21124
                    // can't explaint why modal window displaying over it's body
                    // move list node to top of the elements
                    list.$node.style.zIndex = 9999;
                    console.log('timeout');
                    list.focus();
                }, 0);
            },
            hide: function () {
                list.$node.style.zIndex = '';
                app.activePanelSet.focus();
            },
            click: function () {
                // TODO: add check into mag-component-modal
                console.log('click on modal, ' + (app.activePage.activeComponent === list));
                console.log(list.$focusItem.innerHTML);
                if ( app.activePage.activeComponent === list ) {
                    list.emit('click:item', {
                        $item: list.$focusItem
                    });
                }
            }
        }
    }),
    currentOption;


modal.$node.classList.add('select-list');

list.$node.className = 'mag-component-layout-list padded';
list.$node.appendChild(list.$body);
list.$body.className = 'body';
list.$body.title = '';

modal.$counter = modal.$text.parentNode.appendChild(document.createElement('div'));
modal.$counter.className = 'theme-counter';
modal.$counter.appendChild(document.createElement('div'));
modal.$counter.firstChild.className = '';


if ( window.top.stbEvent ) {
    window.top.stbEvent.addListener('message', self.onDeviceStorageListChange = function ( evt ) {
        if ( !modal.visible ) {
            return;
        }

        if ( currentOption.refreshEvent === 'deviceStorageListChange' ) {
            if ( evt.broadcast && (evt.message === 'storage.mount' || evt.message === 'storage.unmount') ) {
                currentOption.getter.call(currentOption, function ( value ) {
                    currentOption.prepareForRender(value, function ( data ) {
                        var focusIndex = 0;

                        data.forEach(function ( item, index ) {
                            if ( item.selected ) {
                                focusIndex = index;
                            }
                        });

                        list.init({
                            focusIndex: focusIndex,
                            data: data,
                            size: data.length > 5 ? 5 : data.length
                        });
                    });
                });
            }
        }
    });
}


// function setCurrentValue ( value ) {

// }

// function getCurrentValue (  ) {

// }

/* eslint no-invalid-this: 0 */
function refreshCurrentList ( data ) {
    console.log('refreshCurrentList ' + this.id);
    console.log(data.length);
    this.list = data;
}


module.exports = function ( data, callback ) {
    var self = this;

    self.focusIndex = 0;

    self.events['saved'] = [
        function ( value ) {
            self.list.forEach(function ( item ) {
                item.selected = item.value === value;
            });
            nodeMap.data[currentOption.id].initialValue = value;
        }
    ];

    data.forEach(function ( item, index ) {
        if ( item.selected ) {
            self.focusIndex = index;
        }
    });
    self.list = data;
    // self.set = setCurrentValue;
    // self.get = getCurrentValue;
    self.refresh = refreshCurrentList;

    listItemRender.call(this, null, function () {
        nodeMap.data[self.id].onclick = function () {
            currentOption = self;
            currentOption.list.forEach(function ( item, index ) {
                if ( item.selected ) {
                    currentOption.focusIndex = index;
                }
            });

            modal.$text.innerText = self.title || gettext('Choose option');

            modal.$counter.firstChild.innerText = currentOption.list.length;

            if ( modal.parent ) {
                if ( app.activePage !== modal.parent ) {
                    modal.parent.remove(modal);
                    app.activePage.add(modal);
                }
            } else {
                app.activePage.add(modal);
            }

            list.init({
                focusIndex: currentOption.focusIndex,
                data: currentOption.list,
                size: currentOption.list.length > 5 ? 5 : currentOption.list.length
            });

            setTimeout(function () {
                modal.show();
            }, 0);
        };

        callback();
    });
};
